import styled from '@emotion/styled';
import { icons } from '@assets/icons';

export const StyledErrorWrap = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const StyledErrorFloatCenter = styled.div`
  width: 630px;
  height: 200px;
  margin: 0 auto;
  text-align: center;

  & .error_icon {
    display: inline-block;
    width: 81px;
    height: 81px;
    background-image: url(${icons.warning_triangle});
  }
  & .error_tit {
    margin: 0 0 20px 0;
    font-weight: 700;
    font-size: 48px;
  }

  & .error_txt {
    margin: 0;
    font-weight: 500;
    font-size: 30px;
  }

  & .error_btn {
    display: inline-block;
    width: 204px;
    height: 57px;
    margin-top: 50px;
  }
`;
